import ContactSection from './components/contact-section';
import Footer from './components/footer';
import Header from './components/header';
import Hero from './components/hero';
import JoinSection from './components/join-section';
import MissionSection from './components/mission-section';
import PathwaySection from './components/pathway-section';
import ProgramsSection from './components/programs-section';

function App() {
  return (
    <div className="min-h-screen bg-hub-cream">
      <Header />
      <main>
        <Hero />
        <MissionSection />
        <ProgramsSection />
        <PathwaySection />
        <JoinSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
